import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import cx from 'classnames';
import Media from 'react-media';
import { SPayIcon } from '@components/Icon';
import { NavigationProps } from './Navigation.type';

const Navigation = ({
  menuList,
  extraButton,
  extra,
  className,
}: NavigationProps) => {
  const [phoneMenuOpen, setPhoneMenuOpen] = useState(false);

  const mergedClassName = cx('navigation-container', className);

  return (
    <nav className={mergedClassName}>
      <div className="content">
        <NavLink to="/">
          <SPayIcon width={70} height={36} />
        </NavLink>

        <Media
          queries={{
            medium: '(max-width: 767px)',
            large: '(min-width: 768px)',
          }}
        >
          {(matches) => (
            <>
              {matches.medium && (
                <>
                  <button
                    type="button"
                    className={`menu-toggle${phoneMenuOpen ? ' open' : ''}`}
                    onClick={() => setPhoneMenuOpen(!phoneMenuOpen)}
                  >
                    <div className="bar" />
                    <div className="bar" />
                    <div className="bar" />
                  </button>

                  <div
                    className={`menu-list-phone${phoneMenuOpen ? ' open' : ''}`}
                  >
                    <div className="menu-container">
                      {menuList.map((item) =>
                        item.path.includes('http') ? (
                          <a
                            key={item.path}
                            href={item.path}
                            onClick={() => setPhoneMenuOpen(!phoneMenuOpen)}
                          >
                            {item.title}
                          </a>
                        ) : (
                          <NavLink
                            key={item.path}
                            to={item.path}
                            onClick={() => setPhoneMenuOpen(!phoneMenuOpen)}
                          >
                            {item.title}
                          </NavLink>
                        )
                      )}

                      {(extra || extraButton) && <div className="line" />}

                      {extra}

                      <NavLink
                        to={extraButton?.path}
                        onClick={() => setPhoneMenuOpen(!phoneMenuOpen)}
                      >
                        <button type="button" className="extra-button">
                          {extraButton?.title}
                        </button>
                      </NavLink>
                    </div>
                  </div>
                </>
              )}
              {matches.large && (
                <div className="menu-list">
                  {menuList.map((item) =>
                    item.path.includes('http') ? (
                      <a
                        key={item.path}
                        href={item.path}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {item.title}
                      </a>
                    ) : (
                      <NavLink key={item.path} to={item.path}>
                        {item.title}
                      </NavLink>
                    )
                  )}

                  {extraButton && (
                    <NavLink to={extraButton?.path}>
                      <button type="button" className="extra-button">
                        {extraButton?.title}
                      </button>
                    </NavLink>
                  )}

                  {extra}
                </div>
              )}
            </>
          )}
        </Media>
      </div>
    </nav>
  );
};

export default Navigation;
